import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* fetchMemberTiers({ callbacks }) {
  try {
    const response = yield call(api.fetchMemberTiers);
    yield put(Actions.fetchMemberTiersSuccess(response.data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success, response.data);
    }
  } catch (error) {
    yield put(Actions.fetchMemberTiersFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

function* watchFetchMemberTiers() {
  yield takeLatest(Actions.FETCH_MEMBER_TIERS_REQUEST, fetchMemberTiers);
}

export default function* list() {
  yield all([fork(watchFetchMemberTiers)]);
}
